export default "__VITE_ASSET__BZWzJKqn__"